module.exports = __webpack_public_path__ + "img/womenActive.c084443e.svg";